@if (!readOnly) {
  <div
    ng2FileDrop
    [ngClass]="{ 'file-over': hasDropZoneOver }"
    (fileOver)="fileOver($event)"
    [uploader]="uploader"
    class="panel"
    [class.error]="doesFormHaveError"
    fxLayout="column"
    fxLayoutAlign="center center"
    (click)="documentUpload.click()"
    (keydown.enter)="documentUpload.click()"
    (keydown.space)="$event.preventDefault(); documentUpload.click()"
    tabindex="0"
    role="button"
    aria-label="Browse files to upload"
  >
    <div fxLayout="column" fxLayoutAlign="center center">
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <p class="small-font"><b>BROWSE FILES</b></p>
      <p class="small-font">Drag and Drop Files Here</p>
    </div>
    <input
      type="file"
      id="documentUpload"
      #documentUpload
      ng2FileSelect
      (change)="documentUpload.value = ''"
      [uploader]="uploader"
      [multiple]="multiple"
      [attr.accept]="acceptedFileExtensions?.join(',')"
    />
  </div>
}
<mat-error class="mat-error-document" [class.error]="doesFormHaveError">{{
  errorMessage
}}</mat-error>
<div fxLayout="column">
  @for (file of files; track file) {
    <div>
      <div fxFlex class="files-panel">
        <div
          fxLayout="row"
          fxLayoutAlign="start center"
          fxFlex="95"
          class="file-card"
          [class.file-card-error]="file.hasError"
          [class.file-card-success]="
            file.isTempFile && !file.isUploading && !file.hasError
          "
        >
          <div fxLayout="row" fxLayoutAlign="space-between center" fxFlex>
            <div fxLayout="row" fxLayoutAlign="start center">
              @if (!file.isUploading && !file.hasError) {
                <mat-icon>task</mat-icon>
              }
              @if (file.hasError) {
                <mat-icon>sd_card_alert</mat-icon>
              }
              @if (file.isUploading && !file.hasError) {
                <div class="waiting-spinner">
                  <mat-spinner strokeWidth="2" diameter="24"></mat-spinner>
                </div>
              }
              <span>{{ file.fileName }}</span>
            </div>
            @if (file.hasError) {
              <span class="file-error-message">{{ file.errorMessage }}</span>
            }
          </div>
        </div>
        @if (!readOnly) {
          <div fxFlex="5">
            @if (!file.isUploading || file.hasError) {
              <button
                mat-icon-button
                aria-label="Delete button"
                [disabled]="
                  !file.isTempFile &&
                  !personDetailsMode &&
                  !isTeamDetailsMode &&
                  !deferUpload
                "
                (click)="deleteFile(file)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            }
          </div>
        }
        @if (!personDetailsMode && !isTeamDetailsMode) {
          <div fxFlex="5">
            @if (!file.isUploading || file.hasError) {
              <button
                [disabled]="file.isTempFile"
                mat-icon-button
                aria-label="Download btton"
                (click)="onDownloadFile(file)"
              >
                <mat-icon>download</mat-icon>
              </button>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
